
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/colecoes/[slug]",
      function () {
        return require("private-next-pages/colecoes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/colecoes/[slug]"])
      });
    }
  